"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextStyle = void 0;
const core_1 = require("@tiptap/core");
exports.TextStyle = core_1.Mark.create({
    name: 'textStyle',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'span',
                getAttrs: (element) => {
                    const hasStyles = element.hasAttribute('style');
                    if (!hasStyles) {
                        return false;
                    }
                    return {};
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['span', (0, core_1.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            removeEmptyTextStyle: () => ({ state, commands }) => {
                const attributes = (0, core_1.getMarkAttributes)(state, this.type);
                const hasStyles = Object.entries(attributes).some(([, value]) => !!value);
                if (hasStyles) {
                    return true;
                }
                /**
                 * Start custom code
                 * TODO remove this plugin after: https://github.com/ueberdosis/tiptap/issues/4853
                 */
                const { from, to } = state.selection;
                let childCount = 0;
                // Detect any nested text nodes, which would be removed by the TipTap bug
                state.doc.nodesBetween(from, to, (node) => {
                    if (node.type.name === 'text') {
                        childCount += 1;
                    }
                });
                if (childCount > 1) {
                    console.warn('removeEmptyTextStyle disabled due to bug in TipTap');
                    return false;
                }
                /**
                 * End custom code
                 */
                return commands.unsetMark(this.name);
            },
        };
    },
});
//# sourceMappingURL=text-style.js.map